import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.6664 15.2083C17.0116 15.2083 17.2914 15.4881 17.2914 15.8333C17.2914 16.1784 17.0116 16.4583 16.6664 16.4583H9.99977C9.65459 16.4583 9.37477 16.1784 9.37477 15.8333C9.37477 15.4881 9.65459 15.2083 9.99977 15.2083H16.6664ZM2.89121 3.72471C3.12005 3.49587 3.48231 3.48132 3.7278 3.68158L3.775 3.72471L8.775 8.72471L8.81813 8.77191C9.00505 9.00104 9.00505 9.33216 8.81813 9.5613L8.775 9.6085L3.775 14.6085C3.53092 14.8526 3.13529 14.8526 2.89121 14.6085C2.64713 14.3644 2.64713 13.9688 2.89121 13.7247L7.44932 9.1666L2.89121 4.6085L2.84808 4.5613C2.64782 4.31581 2.66237 3.95354 2.89121 3.72471Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }